export default __webpack_public_path__ + "static/media/City_of_Code_GitHub.0f673201.avif";